import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, AvatarModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.sass'
})
export class LandingComponent implements OnInit {
  showTimeoutDialog = signal(false);

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Check for timeout query parameter
    this.route.queryParams.subscribe(params => {
      if (params['timeout'] === 'true') {
        this.showTimeoutDialog.set(true);

        // Remove the query parameter from URL without refreshing
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { timeout: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
    });
  }

  closeTimeoutDialog(): void {
    this.showTimeoutDialog.set(false);
  }
}
